export enum Font {
  WorkSans = 'work-sans',
  Rajdhani = 'rajdhani',
}
